import type { FC } from 'react';

import LegalDocument from '@/features/legal/components/LegalDocument';
import { useTermsPage } from '@/features/legal/hooks/useTermsPage.hook';

const TermsPage: FC = () => {
  const { content, lastUpdated } = useTermsPage();

  return <LegalDocument content={content} lastUpdated={lastUpdated} />;
};

export default TermsPage;
